import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { Row, Col } from "react-bootstrap";
import { ArrowLeft } from "iconsax-react";

import personalImg from "../../../image/purchase/personal-subscription.png";
import rocket_big from "../../../image/purchase/rocket-big.png";
import rocket_medium from "../../../image/purchase/rocket-medium.png";
import rocket_small from "../../../image/purchase/rocket-small.png";
import { cartApi, salesPackagesApi } from "../../../utility/api/apiList";

import { ROUTE_PAYMENT } from "../../../routes";
import { sortByProperty } from "../../../libs/sortByProperty";

import {
  showInfoAlert,
  closeAlert,
} from "../../../redux/actions/alert/alertActions";
import useAxios from "../../../hooks/useAxios";
import uuidv4 from "../../../libs/getUuIdV4";
import scrollToTop from "../../../libs/scrollToTop";
import { getCookieId } from "../../../libs/getCookieID";

import PersonalPurchaseSkeleton from "./personalPurchaseSkeleton";
import LayoutPurchaseComponent from "../../../components/public/purchase/layoutPurchase";
import PersonalPurchaseCardComponent from "../../../components/public/purchase/personalPurchase/cards";
import SimsFilterComponent from "../../../components/public/simsFilter";
import ButtonComponent from "../../../components/public/button";

import {
  Wrapper,
  StyledOption,
  StyledValueAddedTax,
} from "./styledPersonalPurchase";

export const subjectOptions = (gradeList) => {
  return gradeList.map((item) => {
    return {
      label: item.name,
      value: item.id,
    };
  });
};

export const ValueAddedTax = () => {
  return (
    <StyledValueAddedTax className="p-0 mb-0 text-center text-md-end">
      توجه کنید، %10 مالیات بر ارزش افزوده به قیمت همه اشتراک‌ها اضافه می‌شود.
    </StyledValueAddedTax>
  );
};

const PersonalPurchasePageContainer = () => {
  const [gradePersonalList, setGradePersonalList] = useState([]);

  const [personalOptionResultArraySelected, setPersonalOptionResultArraySelected] =
    useState([]);

  const [selectedOption, setSelectedOption] = useState();
  const [sortedList, setSortedList] = useState(["3", "6", "12"]);

  const history = useHistory();
  const userDetail = useSelector((state) => state.userDetail);
  const location = useLocation();
  const dispatch = useDispatch();

  const activateSubsctibtion = location.state?.simInfoData?.singleSimDetail.grade[0];

  const {
    data: personalPackagePurchaseList,
    isLoading: personalPurchaseLoading,
    run: salesPackageRun,
  } = useAxios({
    url: salesPackagesApi,
    params: {
      page_size: 100,
    },
  });

  const { run: postToCartRun } = useAxios({
    url: cartApi,
    method: "post",
  });

  const images = [rocket_small, rocket_medium, rocket_big];

  useEffect(() => {
    scrollToTop();
    document.title = "اشتراک شخصی";
    salesPackageRun().then((response) => {
      const arrayPackage = response.data.results;

      if (!userDetail.isLogin) {
        dispatch(showInfoAlert("لطفا ابتدا وارد شوید"));
      } else {
        if (!activateSubsctibtion) {
          dispatch(showInfoAlert("لطفا ابتدا پایه تحصیلی خود را انتخاب کنید."));
        } else if (!activateSubsctibtion?.active) {
          dispatch(closeAlert());
          dispatch(
            showInfoAlert(
              `بسته های پایه  ${activateSubsctibtion?.name} فعال نمی باشند `
            )
          );
        }

        let arrayList = [];
        let outputList = [];
        for (let index = 0; index < arrayPackage.length; index++) {
          arrayList.push({
            id: arrayPackage[index].grade.id,
            name: arrayPackage[index].grade.name,
          });
        }

        for (let index = 0; index < Object.keys(arrayList).length; index++) {
          let findItem = outputList.find((item) => item.id == arrayList[index].id);
          if (findItem !== undefined) {
          } else {
            outputList.push({
              id: arrayList[index].id,
              name: arrayList[index].name,
            });
          }
        }
        setGradePersonalList(outputList.sort(sortByProperty("id")));
      }
    });
  }, []);

  useEffect(() => {
    if (activateSubsctibtion?.active && personalPackagePurchaseList) {
      const filteredArray = personalPackagePurchaseList?.results.filter(
        (item) => item.grade.id == activateSubsctibtion.id
      );
      setPersonalOptionResultArraySelected(filteredArray);
      setSelectedOption(activateSubsctibtion.id);
    }
  }, [personalPackagePurchaseList]);

  useEffect(() => {
    if (selectedOption) {
      let sortList = personalOptionResultArraySelected.sort(
        sortByProperty("month_count")
      );
      setSortedList(sortList);
    }
  }, [personalOptionResultArraySelected]);

  const handleChangePersonalOption = (e) => {
    const filteredArray = personalPackagePurchaseList.results.filter(
      (item) => item.grade.id == e.value
    );
    setPersonalOptionResultArraySelected(filteredArray);
    setSelectedOption(e.value);
    dispatch(closeAlert());
  };

  const handleSubmitPersonalPurchase = (e) => {
    let cookieIdAxios = getCookieId();
    if (userDetail.isLogin) {
    } else if (cookieIdAxios === "") {
      const unique = uuidv4();
      document.cookie = `id=${unique}`;
      cookieIdAxios = unique;
    }
    let arraySubmit = [
      {
        grade: null,
        count: 1,
        unitoftime: null,
        salespackage: e.target.name,
      },
    ];
    let data = {
      data: arraySubmit,
      cookieId: userDetail.isLogin ? null : cookieIdAxios,
    };

    postToCartRun({ ...data }).then(() => {
      history.push({
        pathname: ROUTE_PAYMENT,
        simID: location.state?.simInfoData?.singleSimDetail.id,
      });
    });
  };

  return (
    <LayoutPurchaseComponent
      cardTitle="اشتراک شخصی"
      rowClassName="flex-grow-1"
      $height="650px"
    >
      <Wrapper className="d-flex flex-column justify-content-around align-items-center">
        <img src={personalImg} alt="اشتراک شخصی" className="mb-3 mt-1" />
        <SimsFilterComponent
          options={subjectOptions(gradePersonalList)}
          defaultValue={
            activateSubsctibtion?.active && {
              label: activateSubsctibtion?.name,
              value: activateSubsctibtion?.id,
            }
          }
          placeholder={"پایه تحصیلی خود را انتخاب کنید."}
          name="type-edit-company"
          onChange={handleChangePersonalOption}
          components={{ StyledOption }}
          closeMenuOnSelect={true}
          isSearchable={false}
          className="select-grade mx-auto mb-3 p-0"
          isDisabled={!userDetail.isLogin}
        />
        <Row className="d-flex flex-column flex-md-row justify-content-around align-items-center">
          {(selectedOption
            ? sortedList.filter((item) => !item.is_not_buyable)
            : sortedList
          ).map((item, index) => {
            return (
              <Col className="pt-4" key={index}>
                {personalPurchaseLoading ? (
                  <PersonalPurchaseSkeleton />
                ) : (
                  <PersonalPurchaseCardComponent
                    classname={`mx-auto justify-content-end ${
                      selectedOption && "personal-card-purchase"
                    }`}
                    packageImage={
                      <img
                        src={images[index]}
                        alt="اشتراک ماهانه"
                        className="image-fluid"
                      />
                    }
                    showPriceAndDiscount={selectedOption}
                    haveDiscount={item?.discount}
                    discountPercent={item?.discount_percent}
                    monthCount={selectedOption ? item.month_count : item}
                    priceAfterDiscount={item.discount}
                    priceBeforeDiscount={item.price}
                    totalprice={item.price}
                  >
                    <ButtonComponent
                      name={item.id}
                      onClick={handleSubmitPersonalPurchase}
                      className={
                        !userDetail.isLogin || !selectedOption
                          ? "disactive-btn"
                          : "active-btn"
                      }
                      disabled={!userDetail.isLogin || !selectedOption}
                    >
                      انتخاب
                      <ArrowLeft
                        size="20"
                        className="m-1"
                        onClick={(e) => e.stopPropagation()}
                      />
                    </ButtonComponent>
                  </PersonalPurchaseCardComponent>
                )}
              </Col>
            );
          })}
        </Row>
        <Row className="pt-4">
          <ValueAddedTax />
        </Row>
      </Wrapper>
    </LayoutPurchaseComponent>
  );
};

export default PersonalPurchasePageContainer;
